<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="paso == 1">
                <h2>Selección de entrada</h2>
                <ul class="contenedoraplicaciones">
                <!-- <li v-if="!configEnvio.seguimiento && params.get('accion') != 'publicar'" @click="configEnvio.entrada = 'archivo'; $router.push('/selectdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/carpetas.png" width="70%" />
                        </div>
                        <p>Archivo</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Un archivo de cualquier tipo a un directorio privado de uno o varios empleados.</span>
                </li> -->
                <!-- <li v-if="configEnvio.seguimiento || params.get('accion') == 'publicar'" class="tipodocumento inactive">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/carpetas.png" width="70%" />
                        </div>
                        <p>Archivo</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Un archivo de cualquier tipo a un directorio privado de uno o varios empleados.</span>
                </li> -->
                <li class="tipodocumento inactive">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/carpetas.png" width="70%" />
                        </div>
                        <p>Archivo</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Un archivo de cualquier tipo a un directorio privado de uno o varios empleados.</span>
                </li>
                <li @click="configEnvio.entrada = 'pdf'; $router.push('/selectdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/pdf.png" width="70%" />
                        </div>
                        <p>Documento</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Un documento PDF dirigido a una o varias empresas, áreas, centros o departamentos determinados.</span>
                </li>
                <li @click="configEnvio.entrada = 'contenido'; $router.push('/generatecontent')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/editor-de-texto.png" width="70%" />
                        </div>
                        <p>Contenido</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Una publicación de texto creada por ti dirigido a una o varias empresas, áreas, centros o departamentos determinados.</span>
                </li>
            </ul>
            </template>
            <div style="display:flex;">
                <el-button type="primary" icon="Back" @click="$router.go(-1)" :disabled="leftDisabled" />
                <el-button type="primary" icon="Right" :disabled="rightDisabled" @click="$router.push('/selecttarget')" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'SeleccionEntrada',
    watch: {
    },
    components: {
        
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            acciones: {},
        }
    },
    mounted() {
        this.setFiles([])
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'params'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if(this.files.length == 0) {
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setFiles'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }
    .contenedoraplicaciones {
        width: calc(100% - 5px);
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2.5px;

        @media(max-width: 1500px) {
            flex-direction: column;
        }

        li {
            @media(max-width: 1500px) {
                flex-basis: calc(50% - 20px);
            }

            @media(min-width: 1500px) {
                flex-basis: calc(33.33% - 20px);
                aspect-ratio: 2/1;
            }

            /* Ajusta este valor según tus necesidades */
            box-sizing: border-box;

            div {
                display: flex;
                align-items: center;
                text-align: left;
            }

            p {
                margin: 0px;
            }
        }
    }


    .tipodocumento {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border: 2px solid #a9a9a929;
        margin-bottom: 10px;
        border-radius: 10px;
        font-weight: bold;
        transition: 0.5s;
        justify-content: flex-start;

        &.inactive {
            cursor: not-allowed;
            color: gray;
            background-color: #a9a9a929;
            border-color: #a9a9a929;

            &:hover {
                color: gray;
                background-color: #a9a9a929;
            border-color: #a9a9a929;
            }
        }

        &:hover {
            background-color: #a9a9a929;
            border-color: #a9a9a929;
        }

        .icono {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #0985e325;
            border-radius: 10px;
            margin-right: 10px;
        }

        .iconoconsulta {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #1abc9c;
            border-radius: 10px;
            margin-right: 10px;
        }
    }
}
</style>